import { ColorHelper } from '../utils/color-helpers';
import { getConfig } from '@sydle/ui-utils';
/**
 * Insert style tokens into html body using package definitions
 */
function setGlobalTokens() {
  const designSystemConfig = getConfig('ui-design-system');
  if (!designSystemConfig) {
    return;
  }
  const primaryColor = designSystemConfig.primaryColor;
  const secondaryColor = designSystemConfig.secondaryColor;
  let style = {};
  if (primaryColor) {
    style = { ...style, '--sy-primary': primaryColor };
    const variants = ColorHelper.getColorVariations(primaryColor);
    variants.forEach((variant) => {
      style = { ...style, [`--sy-primary-${variant.name}`]: variant.value };
    });
  }
  if (secondaryColor) {
    style = { ...style, '--sy-secondary': secondaryColor };
    const variants = ColorHelper.getColorVariations(secondaryColor);
    variants.forEach((variant) => {
      style = { ...style, [`--sy-secondary-${variant.name}`]: variant.value };
    });
  }
  const surfaceVariations = ColorHelper.getSurfaceColorVariations(primaryColor);
  const calculateSurfaceTokens = (surfaceType, primaryColor, defaultColor = '#ffffff') => {
    const variations = ColorHelper.getColorVariations(defaultColor, primaryColor, 0.6);
    const hover = variations.find((variation) => variation.name === 'hover')?.value || defaultColor;
    const active = variations.find((variation) => variation.name === 'active')?.value || defaultColor;
    style = {
      ...style,
      [`--sy-surface-${surfaceType}`]: defaultColor,
      [`--sy-surface-${surfaceType}-hover`]: hover,
      [`--sy-surface-${surfaceType}-active`]: active,
    };
  };
  calculateSurfaceTokens('default', primaryColor);
  const surfaceLight = surfaceVariations.find((surface) => surface.name === 'light');
  if (surfaceLight) {
    calculateSurfaceTokens(surfaceLight.name, primaryColor, surfaceLight.value);
  }
  const surfaceDark = surfaceVariations.find((surface) => surface.name === 'dark');
  if (surfaceDark) {
    calculateSurfaceTokens(surfaceDark.name, primaryColor, surfaceDark.value);
  }
  calculateSurfaceTokens('elevated', primaryColor);
  const styleElement = document.createElement('style');
  styleElement.innerHTML = `:root ${JSON.stringify(style)?.replace(/","/g, '";"').replace(/"/g, '')}`;
  document.head.appendChild(styleElement);
}
setGlobalTokens();
//# sourceMappingURL=setup.js.map